import { APIFactory } from '../api/api.factory'
import DateService from '@/services/DateService'
const ReportsAPI = APIFactory.get('reports');
const ExpenseReportAPI = APIFactory.get('expenseReport')


export default {
    async getPIApprovals() {
        console.log('reportsservice.getReports')

        const { data } = await ReportsAPI.get('?statusTypeIds=2&canApprove=true&includeTotal=true');
        
        return data.map(report => ({
            YourProject: report.projects.map(function (p) { return `${p.projectNumber}-${p.projectName}` }).join(", "),
            SubmitterName: report.submittedByName,
            ReportName: `<a href="/${this.getAreaLink(report)}/${report.expenseReportId}">${this.getExpenseReportName(report)}</a>`,
            Type: this.getExpenseReportType(report),
            //RequiredApprovers: '', TODO:Comment out for now as not working
            Status: report.statusType.displayName,
            YourProjectTotal: report.projects.reduce((total,p) => total + p.total, 0),
            ReimbursementTotal: report.reimbursementTotal,
            IsPercentAmountAllocation: report.isPercentAmountAllocation,
        }
        ));
    },

    async getReportsInProgress(isAdmin) {
        console.log('reportsservice.getReportsInProgress')
        const { data } = await ReportsAPI.getMyReport(isAdmin);
        //        return data;
        return data.map(report => ({
            ExpenseReportId: report.expenseReportId,
            StatusId: report.statusType.id,
            ReportName: `<a href="/${this.getAreaLink(report)}/${report.expenseReportId}">${this.getExpenseReportName(report)}</a>`,            
            Type: this.getExpenseReportType(report),
            Status: report.statusType.displayName,
            ReimbursementTotal: report.reimbursementTotal,
            CreatedBy: report.createdByName,
            CreatedByUserId: report.createdByUserId
        }
        ));
    },

    async getPaidReports() {
        console.log('reportsservice.getMyPaidReport')
        const { data } = await ReportsAPI.getMyPaidReport();
        //        return data;
        return data.map(report => ({
            SubmittedDate: DateService.normalizeDateTime(report.submittedDate),
            PaidDate: DateService.normalizeDateTime(report.paidDate),
            Approvals: report.approvals.filter((a) => a.approvedByName).map((n) => n.approvedByName).join(","),
            ReportName: `<a href="/${this.getAreaLink(report)}/${report.expenseReportId}">${this.getExpenseReportName(report)}</a>`,
            Project: report.projects.map(function (p) { return `${p.projectNumber}-${p.projectName}`}).join(", "),
            Type: this.getExpenseReportType(report),
            Status: report.statusType.displayName,
            ReimbursementTotal: report.reimbursementTotal
        }
        ));
    },

    async getAdminOneApprovals() {
        console.log('reportsservice.getAdminApporvals')
        const { data } = await ReportsAPI.get('?statusTypeIds=3&includeTotal=true');

        return data.map(report => ({
            SubmittedDate: DateService.normalizeDateTime(report.submittedDate),
            SubmitterName: report.submittedByName,
            Approvals: report.approvals.filter((a) => a.approvedByName).map((n) => n.approvedByName).join(","),
            ReportName: `<a href="/${this.getAreaLink(report)}/${report.expenseReportId}">${this.getExpenseReportName(report)}</a>`,
            Project: report.projects.map(function (p) { return `${p.projectNumber}-${p.projectName}` }).join(", "),
            Type: this.getExpenseReportType(report),
            Status: report.statusType.displayName,
            ReimbursementTotal: report.reimbursementTotal
        }
        ));
    },

    async getAdminTwoApprovals() {
        console.log('reportsservice.getAdminTwoApporvals')
        const { data } = await ReportsAPI.get('?statusTypeIds=4&includeTotal=true');

        return data.map(report => ({
            Selected: false,
            SubmittedDate: DateService.normalizeDateTime(report.submittedDate),
            SubmitterName: report.submittedByName,
            Approvals: report.approvals.filter((a) => a.approvedByName).map((n) => n.approvedByName).join(","),
            ReportName: `<a href="/${this.getAreaLink(report)}/${report.expenseReportId}">${this.getExpenseReportName(report)}</a>`,
            Project: report.projects.map(function (p) { return `${p.projectNumber}-${p.projectName}` }).join(", "),
            Type: report.isMiscReport ? 'MISC' : 'TER',
            Status: report.statusType.displayName,
            ReimbursementTotal: report.reimbursementTotal,
            ExpenseReportID: report.expenseReportId
        }
        ));
    },

    async getPendingPayments() {
        console.log('reportsservice.getPendingPayments')
        const { data } = await ReportsAPI.get('?statusTypeIds=7&includeTotal=true');

        return data.map(report => ({
            Selected: false,
            SubmitterName: report.submittedByName,
            SubmittedDate: report.approvals[0].isApproved ? DateService.normalizeDateTime(report.approvals[0].approvedDate) : '',
            Type: this.getExpenseReportType(report),
            ReportName: `<a href="/${this.getAreaLink(report)}/${report.expenseReportId}">${this.getExpenseReportName(report)}</a>`,
            Project: report.projects.map(function (p) { return `${p.projectNumber}-${p.projectName}` }).join(", "),
            Approvals: report.approvals.filter((a) => a.approvedByName).map((n) => n.approvedByName).join(","),
            Status: report.statusType.displayName,
            ReimbursementTotal: report.reimbursementTotal,
            PaidDate: "",
            Pay: report.expenseReportId
        }
        ));
    },

    async getAnalysisReport(searchCriteria) {
        const { data } = await ReportsAPI.getAnalysisReport(searchCriteria);
        return data.map(report => ({
            ReportName: this.getExpenseReportName(report),
            ReportLink: `/${this.getAreaLink(report)}/${report.expenseReportId}`,
            PaidDate: report.paidDate,
            SubmittedDate: report.submittedDate,
            SubmitterName: report.submittedByName,
            Approvals: report.approvals.filter((a) => a.approvedByName).map((n) => n.approvedByName).join(", "),
            Projects: report.projects.map(function (p) { return `${p.projectNumber}-${p.projectName}` }).join(", "),
            Type: this.getExpenseReportType(report),
            Status: report.statusType.displayName,
            ProjectTotal: report.projectTotal,
            ReimbursementTotal: report.reimbursementTotal,
            AirfareTotal: report.totals ? report.totals.airfareTotal : null,
            LodgingTotal: report.totals ? report.totals.lodgingTotal : null,
            MealsTotal: report.totals ? report.totals.mealsTotal : null,
            POVMileageTotal: report.totals ? report.totals.povMileageTotal : null,
            MiscTotal: report.totals ? report.totals.miscTotal : null,
            CarRentalTotal: report.totals ? report.totals.carRentalTotal : null,
            GroundTransportationTotal: report.totals ? report.totals.groundTransportationTotal : null,
            MiscReportItemTotal: report.totals ? report.totals.miscReportItemTotal : null
        }
        ));
    },

    getExpenseReportName(reportItem) {
        return reportItem.isMiscReport ? reportItem.reportName : reportItem.tripName;
    },

    getExpenseReportType(reportItem) {
        return reportItem.isMiscReport ? "MISC" : 'TER';
    },

    getAreaLink(reportItem) {
        return reportItem.isMiscReport ? 'misc-expense-report' : 'review-submit'
    },
    async deleteExpenseReport(erID) {
        const { data } = await ExpenseReportAPI.deleteExpenseReport(erID)
        return data;
    },
}